/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var ApprovalsFileIcon = createIcon("ApprovalsFileIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#3894FF';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24Z",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 25a1.414 1.414 0 012 0l6 6a1.414 1.414 0 11-2 2l-6-6a1.414 1.414 0 010-2Zm30-8a1.414 1.414 0 010 2L24 34l-7-7a1.414 1.414 0 112-2l5 5 13-13a1.414 1.414 0 012 0Zm-8 2-6 6a1.414 1.414 0 11-2-2l6-6a1.414 1.414 0 112 2Z",
    fill: "#fff"
  }));
}, {
  "i18nKey": "svg.ApprovalsFileIcon",
  "replaceColor": true
});